import React from "react";
import { PieChart, Pie, Cell } from "recharts";

const PieChartComponent = ({ data }) => {
  return (
    <PieChart width={140} height={150}>
      <Pie
        data={data}
        cx={70}
        cy={58}
        innerRadius={30}
        outerRadius={60}
        paddingAngle={0}
        startAngle={90}
        endAngle={-270}
        dataKey="value"
      >
        {data.map(({ color }, index) => (
          <Cell key={`cell-${index}`} fill={color} />
        ))}
      </Pie>
    </PieChart>
  );
};

export default PieChartComponent;
